import AI_ASSISTANT_SETTINGS_CONFIG from '../../../configs/aiAssistantSettings.config';
import aiAssistantSettingControls from '../../../consts/aiAssistant/aiAssistantSettingControls';
import AiAssistantSettingSegmentedTile from './AiAssistantSettingSegmentedTile';
import AiAssistantSettingToggleTile from './AiAssistantSettingToggleTile';

const TILE_BY_CONTROL = {
    [aiAssistantSettingControls.TOGGLE]: AiAssistantSettingToggleTile,
    [aiAssistantSettingControls.SEGMENTED]: AiAssistantSettingSegmentedTile,
};

const AiAssistantSettingTile = ({settingName, isAlone, value, onChange}) => {
    const setting = AI_ASSISTANT_SETTINGS_CONFIG[settingName];
    const Tile = TILE_BY_CONTROL[setting.control];

    return <Tile setting={setting} isAlone={isAlone} value={value} onChange={onChange} />;
};

export default AiAssistantSettingTile;
